import { render, staticRenderFns } from "./IntelligentManufacturingCollege.vue?vue&type=template&id=75d55829&scoped=true"
import script from "./IntelligentManufacturingCollege.vue?vue&type=script&lang=js"
export * from "./IntelligentManufacturingCollege.vue?vue&type=script&lang=js"
import style0 from "./IntelligentManufacturingCollege.vue?vue&type=style&index=0&id=75d55829&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d55829",
  null
  
)

export default component.exports